//import { DatePipe } from '@angular/common';
import {
  Component, OnInit, ViewEncapsulation, Input, Inject, ViewChild, TemplateRef, ViewContainerRef, ChangeDetectionStrategy,
  ElementRef, Renderer2, ChangeDetectorRef
} from '@angular/core';
import { CdsService } from '@nexxe/cds'; 
import { ChannelService, DmDataModelManagerService, DmWidgetManagerService, Message } from '@nexxe/core';
import { IStoreChange, IChangeDetector,IWidget } from '@nexxe/core-types';
import { InjectionContext } from '@nexxe/plugin-injector';
import { of, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LocalizationService } from '@nexxe/shared';
declare var userInfo: any;
@Component({
  selector: 'bn-registration-header-v2-component',
  templateUrl: './bn-registration-header-v2.component.html',
  styleUrls: ['./bn-registration-header-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class BnRegHeaderV2Component implements OnInit, IChangeDetector {
  
  @ViewChild("languageSettingsPopupContainer", { read: ViewContainerRef, static: true }) languageSettingsPopupContainerRef: ViewContainerRef;
  @ViewChild("languageSettingsPopupTemplate", { read: TemplateRef, static: true }) languageSettingsPopupTemplateRef: TemplateRef<any>;
  @ViewChild("popupContainer", { read: ViewContainerRef, static: true }) popupContainerRef: ViewContainerRef;
  @ViewChild("popupTemplate", { read: TemplateRef, static: true }) popupTemplateRef: TemplateRef<any>;

  alertBarmsgTitle: any = "";
  isInvited: any = false;
  instructions: any;
  currentProject: any;
  currentProjectMetaData: any;
  widgetManifestPath: string;
  widgetConfig: any;
  widgetChildContext: InjectionContext;
  bpc;
  widgetManagerId;
  widgetId;
  dataModelId;
  private streamSubscription: Subscription = new Subscription();
  buttonManifestPath: string;
  logo_gep:any;
  logo_client:any;
  languageButtonConfig:any;
  showClientBranding:boolean= true;
  showLanguageSettingIcon:boolean;
  selectedLanguage:any;
  languagelist:any;
  languageIcon:any;
  partnershipText:any;
  isSubmitButtonClickedListener:any;
  applyAdditionalStyles:any;

  constructor(
    @Inject(ChangeDetectorRef) public cdRef: ChangeDetectorRef,
    private dmDataModelManagerService: DmDataModelManagerService,
    private dmWidgetManagerService: DmWidgetManagerService,
    public channelService: ChannelService,
    private cdsService: CdsService,
    private localizationService: LocalizationService,
    private _elementRef: ElementRef,
    private _renderer: Renderer2,
   // private datePipe: DatePipe
  ) { }
  
  ngOnInit(): void {  
    let interval = setInterval(() => {
      if (this.localizationService.translate("BN_regv2_InPartnership") != "BN_regv2_InPartnership") {
        clearInterval(interval);
      }
      this.partnershipText=this.localizationService.translate("BN_regv2_InPartnership");
      this.cdRef.detectChanges();
    }, 10); 
    this.showLanguageSettingIcon = userInfo.IsInvited || userInfo.IsDirectLink; 
    this.bpc = ((userInfo.IsDirectLink) ? userInfo.BuyerInvitationDetails.BuyerPartnerCode : (userInfo.IsInvited) ? userInfo.PartnerData.BPC : null ) 
    this.logo_gep = userInfo.ContentURL + "cumuluscontent/logo/bn_client_reg_logo_GEP.png";
    this.logo_client = userInfo.ContentURL + "cumuluscontent/logo/bn_client_reg_logo_"+this.bpc+".png"
    this.isInvited = userInfo.IsInvited;
    this.currentProject = this.dmDataModelManagerService.getById('currentProject');
    this.currentProjectMetaData = this.dmDataModelManagerService.getById(this.currentProject);
    this.buttonManifestPath = `${this.currentProjectMetaData.connectors['nexxe.button'].name}@${this.currentProjectMetaData.connectors['nexxe.button'].version}`;
    this.bindBnRegistrationFlag();
    this.languageButtonConfig = {
      config: {
        id: `Submit`,
        title: this.localizationService.translate("SN_Registration_Submit"),
        disable: false,
        whiteSecondaryBtn: false,
        flat: true,
        isFloating: false,
        styleClass: "language-button triangle-down"
      },
      callback: {}
    }; 
    let interval1 = setInterval(() => {
      if(this.dmDataModelManagerService.has("allLanguages")){
        this.languagelist = this.dmDataModelManagerService.getById("allLanguages")['LanguageList']; 
        this.selectedLanguage = this.languagelist.find(e => e["code"] == userInfo.UserContext.Culture).displayName;
        this.cdRef.detectChanges();
        clearInterval(interval1);
      }  
    },5);
  }


  bindBnRegistrationFlag() {
    this.isSubmitButtonClickedListener = this.channelService.subscribe(this.processMessage.bind(this), 'bn-entry-component', this.bindBnSubmitButtonClickedFlag.bind(this))
    this.streamSubscription.add(this.isSubmitButtonClickedListener);
  }

  bindBnSubmitButtonClickedFlag(message: Message) {
    if (message.from == 'isSubmitButtonClicked' || message.from == 'isVerifyCodeButtonClicked') {
      this.applyAdditionalStyles = true;
      this.showLanguageSettingIcon = false;
      this.cdRef.detectChanges();
    } 
  }

  processMessage() {
    return of(true);
  }
  
  loadLanguageSettings() {
    const languageSettingsManifestPath = `${this.currentProjectMetaData.connectors['nexxe.bn-language-settings-reg-v2'].name}@${this.currentProjectMetaData.connectors['nexxe.bn-language-settings-reg-v2'].version}`;
    this.loadModule(languageSettingsManifestPath, {}, this);
    this.languageSettingsPopupContainerRef.clear();
    let config = {}, scope = this;
    this.languageSettingsPopupContainerRef.createEmbeddedView(this.languageSettingsPopupTemplateRef,
      {
        manifestPath: languageSettingsManifestPath,
        config: { config, scope }
      }
    );
    this.showLanguageSettings();
  }
 
  private loadModule(path: string, config: any, scope: any): void {
    this.popupContainerRef.clear();
    this.popupContainerRef.createEmbeddedView(this.popupTemplateRef,
      {
        manifestPath: path,
        config: { config, scope }
      }
    );
  }

  showLanguageSettings() {
    let element = this._elementRef.nativeElement.querySelector('.languageSettings-wrapper');
    this._renderer.removeClass(element, 'hidewrapper')
  }

  hideLanguageSettings(id?: string) {
    this.languageSettingsPopupContainerRef.clear();
    let element = this._elementRef.nativeElement.querySelector('.languageSettings-wrapper');
    this._renderer.addClass(element, 'hidewrapper');
    // if(id == "language-settings")
    //   this._elementRef.nativeElement.querySelector('#nexx-rightheader-navigation-LanguageSettings').focus();
  }

  hidePopup(id?: string) {
    let element = this._elementRef.nativeElement.querySelector('.popup-wrapper');
    this._renderer.addClass(element, 'hidewrapper')
    if(id == "user-profile")
      this._elementRef.nativeElement.querySelector('#userProfileIcon').focus();
  }

  skipClientLogo(event)
  {
    this.showClientBranding = false;
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void { }
  ngOnDestroy(): void { 
    this.streamSubscription.unsubscribe();
  }

  onSubmitButtonInitialize(_outletConfig) { }
  onSubmitButtonDeinitialize(outletConfig) { }
  onSubmitButtonActivate(context: InjectionContext) {
    // var isEnabled = false;
    // this.submitButtonContext = context;
    // if(this.dmDataModelManagerService.has("DisclaimerInfo")) {
    //   isEnabled = this.dmDataModelManagerService.getIn("DisclaimerInfo", ["disclaimerInfo", "isTermsAndConditionsChecked"]);
    // }
    // this.submitButtonConfig.config.disable = !isEnabled;
    // this.submitButtonContext.resolved.refrences.component.instance.config = Object.assign({}, this.submitButtonConfig.config);
  }

  onWidgetActivate(event) {
    this.widgetChildContext = event;
  }
  onDeinitialize(event) { }
  onInitialize(event) { } 

  onActivate(context: InjectionContext) {
   
  }

}
